import React from 'react';
export function Guarantee() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(240,253,244) 100%)'
  }} data-id="element-152">
      <div className="mx-auto max-w-3xl" data-id="element-153">
        {/* Card */}
        <div className="rounded-2xl overflow-hidden shadow-sm" style={{
        border: '1px solid rgba(34, 197, 94, 0.3)'
      }} data-id="element-154">
          {/* Header */}
          <div className="px-6 py-5 text-center" style={{
          background: 'linear-gradient(135deg, rgb(21,128,61), rgb(22,163,74))'
        }} data-id="element-155">
            <div className="text-5xl mb-3" data-id="element-156">🛡️</div>
            <h2 className="text-xl sm:text-2xl font-black text-white m-0" data-id="element-157">
              GARANTÍA MEGAPACK™ — 7 DÍAS
            </h2>
          </div>

          {/* Body */}
          <div className="px-6 py-6 text-center" style={{
          backgroundColor: 'rgb(240, 253, 244)'
        }} data-id="element-158">
            <p className="text-sm text-gray-600 m-0 mb-2" data-id="element-159">
              Abrís los 6 tomos. Revisás los 6 bonos. Los usás para estudiar si
              querés.
            </p>
            <p className="text-sm text-gray-600 m-0 mb-5" data-id="element-160">
              Si en 7 días no es lo que esperabas:
            </p>

            <p className="text-3xl font-black text-green-700 m-0 mb-3" data-id="element-161">
              Te devolvemos el 100%.
            </p>
            <p className="text-base font-black text-gray-900 m-0" data-id="element-162">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 text-center border-t" style={{
          backgroundColor: 'rgb(255,255,255)',
          borderColor: 'rgba(34, 197, 94, 0.15)'
        }} data-id="element-163">
            <p className="text-xs text-gray-500 m-0 leading-5" data-id="element-164">
              La confianza que tenemos en el Megapack Nutrición Carrera Resuelta
              nos permite hacer esa promesa sin dudar.
              <br data-id="element-165" />
              Más de 400 estudiantes de todo el país ya lo saben.
              <br data-id="element-166" />
              La tasa de devoluciones es menor al 1%.
            </p>
          </div>
        </div>
      </div>
    </section>;
}